module.exports = __webpack_public_path__ + "img/defaultProfessionTaskHero.6166be1.jpg";